<div class="custom-clock" [hidden]="isAppswitch">
  <div class="clock" #clock>
    <div class="outer-clock-face" #outerClockFace>
      <div class="marking marking-one"></div>
      <div class="marking marking-two"></div>
      <div class="marking marking-three"></div>
      <div class="marking marking-four"></div>
      <div class="inner-clock-face" #innerClockFace>
        <div class="hand hour-hand" #hourClockHand></div>
        <div class="hand min-hand" #secondClockHand></div>
        <div class="hand second-hand" #minClockHand></div>
      </div>
    </div>
  </div>

  <div class="clock-time flex-column  flex-center-start ml-2">

    <!-- Clocked In -->
    <div *ngIf="tech?.clockedIn">
      <p class="mb-1 font-bold font-secondary-900 font-16 uppercase">{{clockInTime}} - {{day}}, {{this.currentLang === 'fr' ? date: (date |
        date:'mediumDate')}}</p>
      <p class="mb-1 font-gray-45 font-14">{{loggedHours}}</p>
    </div>

    <!-- Clocked Out -->
    <p class="mb-1 font-bold font-secondary-900 font-16 uppercase" *ngIf="!tech?.clockedIn">{{time}} - {{day}}, {{this.currentLang === 'fr' ? date: (date |
      date:'mediumDate')}}</p>
    <button *ngIf="!isProcessing" class="btn btn-primary font-bold font-14 clock-in-out-btn"
      (click)="handleClockStatusUpdate()">
      <!-- Clock {{tech?.clockedIn? 'out': 'in'}} -->
      {{(tech?.clockedIn ? 'tech-app.clock-out' :
      'tech-app.clock-in') | translate }}
    </button>
  </div>
</div>

<div class="custom-clock " [hidden]="!isAppswitch">
  <div class="display-flex-none">
    <div class="clock clock-admin" #clockAdmin>
      <div class="outer-clock-face" #outerClockFaceAdmin>
        <div class="marking marking-one"></div>
        <div class="marking marking-two"></div>
        <div class="marking marking-three"></div>
        <div class="marking marking-four"></div>
        <div class="inner-clock-face" #innerClockFaceAdmin>
          <div class="hand hour-hand" #hourClockHandAdmin></div>
          <div class="hand min-hand" #secondClockHandAdmin></div>
          <div class="hand second-hand" #minClockHandAdmin></div>
        </div>
      </div>


    </div>

    <div class="text-center clock-content">
      <!-- <div *ngIf="tech?.clockedIn">
        <p class="mb-1 font-bold font-black font-16 text-uppercase" >{{clockInTime}}</p>
        <p class="mb-1 font-gray-35 font-11 text-center" >{{date | date:'mediumDate'}}</p>
        <p class="mb-1 font-gray-35 font-11 text-center" >{{day}} </p>
      </div> -->

      <!-- *ngIf="!tech?.clockedIn" -->
      <div>
        <p class="mb-1 font-bold font-black font-16 text-uppercase">{{time}}</p>
        <p class="mb-1 font-gray-35 font-11 text-center">{{this.currentLang === 'fr' ? date: (date |
          date:'mediumDate')}} </p>
        <p class="mb-1 font-gray-35 font-11 text-center">{{day}}</p>
      </div>

      <p *ngIf="!isProcessing" class="font-primary font-11 text-center pointer"
        [ngClass]="{'main-app-clock-btn p-2': isMainApp, 'underline': !isMainApp }" (click)="handleClockStatusUpdate()">
        <!-- <i class="fal fa-clock mr-2" *ngIf="isMainApp"></i>Clock {{tech?.clockedIn? 'out': 'in'}} -->
        <i class="fal fa-clock mr-2" *ngIf="isMainApp"></i>{{(tech?.clockedIn ? 'tech-app.clock-out' :
        'tech-app.clock-in') | translate }}
      </p>



      <!-- Clocked In -->
      <!-- <div *ngIf="tech?.clockedIn">
        <p class="mb-0 font-bold font-secondary-900 font-16 uppercase" >{{clockInTime}} - {{day}}, {{date | date:'mediumDate'}}</p>
        <p class="m-0 font-gray-45 font-14">{{loggedHours}}</p>
      </div> -->

      <!-- Clocked Out -->
      <!-- <p class="m-0 font-bold font-secondary-900 font-16 uppercase" *ngIf="!tech?.clockedIn">{{time}} - {{day}}, {{date | date:'mediumDate'}}</p>
      <button *ngIf="!isProcessing" class="btn btn-primary font-bold font-14 clock-in-out-btn"
        (click)="handleClockStatusUpdate()">
        Clock {{tech?.clockedIn? 'out': 'in'}}
      </button> -->
    </div>
  </div>
</div>